import { connect } from 'react-redux';

import { IState } from '../../../../../store';
import { SubmitButton } from './SubmitButton';

export const SubmitButtonContainer = connect(
  (state: IState) => ({
    formStatus: state.feedback.status,
  }),
)(SubmitButton);
